module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-user-task-container"
  }, [_c('div', {
    staticClass: "to-user-task-container__header"
  }, [(_vm.theActiveUser) ? _c('h2', {
    staticClass: "to-user-title"
  }, [_vm._v(_vm._s(_vm.theActiveUser.name))]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "do-select",
    domProps: {
      "value": null
    },
    on: {
      "change": function($event) {
        return _vm.$emit('setTheActiveUserId', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Skift bruger..")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n        " + _vm._s(user.name) + "\n      ")])
  })], 2)]), _vm._v(" "), (_vm.schoolYear && _vm.theActiveUser) ? _c('UserTasks', {
    attrs: {
      "isShowHeader": false,
      "initialStartDate": _vm.schoolYear.employee_time_start,
      "initialEndDate": _vm.schoolYear.employee_time_end,
      "user_id": _vm.theActiveUser.id,
      "user_calendar_id": _vm.theActiveUser.user_calendar_id,
      "user_name": _vm.theActiveUser.name,
      "isShowPrintButton": false,
      "initialIsShowScheduled": false,
      "isCanSeeOtherUsers": false,
      "isReactive": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d46d202a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsUserTasks.vue
// module id = 1823
// module chunks = 1